import type { Template } from "@/types";

export const LA_06_H3_V3: Template[] = [
{
    id: "la-06-h3v3-01",
    name: "LA 01 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 106, y: 58, width: 176, height: 116, rotation: 0, imageRotation: 0 },
            { id: "2", x: 106, y: 180, width: 176, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 106, y: 303, width: 176, height: 115, rotation: 0, imageRotation: 0 },
            { id: "4", x: 288, y: 58, width: 245, height: 359, rotation: 0, imageRotation: 0 },
            { id: "5", x: 707, y: 58, width: 245, height: 359, rotation: 0, imageRotation: 0 },
            { id: "6", x: 959, y: 58, width: 245, height: 359, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-02",
    name: "LA 02 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 113, y: 41, width: 265, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 384, y: 41, width: 135, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 384, y: 241, width: 135, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 742, y: 41, width: 431, height: 252, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 300, width: 212, height: 134, rotation: 0, imageRotation: 0 },
            { id: "6", x: 961, y: 300, width: 212, height: 134, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-03",
    name: "LA 03 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 103, y: 41, width: 431, height: 252, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 300, width: 212, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 300, width: 212, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 754, y: 41, width: 265, height: 394, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1026, y: 41, width: 135, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1026, y: 243, width: 135, height: 192, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-04",
    name: "LA 04 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 113, y: 41, width: 302, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 113, y: 243, width: 302, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 421, y: 41, width: 106, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 421, y: 176, width: 106, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 421, y: 309, width: 106, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 709, y: 74, width: 493, height: 327, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-05",
    name: "LA 05 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 103, y: 40, width: 212, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 40, width: 212, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 103, y: 328, width: 139, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 250, y: 328, width: 139, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 396, y: 328, width: 139, height: 107, rotation: 0, imageRotation: 0 },
            { id: "6", x: 811, y: 40, width: 288, height: 394, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-06",
    name: "LA 06 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 87, width: 420, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 427, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 87, width: 207, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 641, y: 243, width: 207, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 855, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-07",
    name: "LA 07 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 87, width: 420, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 641, y: 87, width: 207, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 427, y: 87, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 427, y: 243, width: 206, height: 148, rotation: 0, imageRotation: 0 },
            { id: "5", x: 855, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-08",
    name: "LA 08 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 87, width: 420, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 427, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 641, y: 87, width: 207, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 855, y: 87, width: 206, height: 304, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 87, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1068, y: 243, width: 206, height: 148, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-09",
    name: "LA 09 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 50, y: 60, width: 134, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 191, y: 60, width: 275, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 242, width: 275, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 333, y: 242, width: 134, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 474, y: 60, width: 499, height: 357, rotation: 0, imageRotation: 0 },
            { id: "6", x: 980, y: 60, width: 245, height: 357, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h3v3-10",
    name: "LA 10 - H3V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h3_v3_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 50, y: 60, width: 134, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 191, y: 60, width: 275, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 242, width: 275, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 333, y: 242, width: 134, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 474, y: 60, width: 245, height: 357, rotation: 0, imageRotation: 0 },
            { id: "6", x: 727, y: 60, width: 499, height: 357, rotation: 0, imageRotation: 0 }
    ],
}
];